<div class="container-fluid anim-loading">
  <div class="page-title page-title--columns">
    <div class="page-title__left"><h2 i18n>Motivos de Invalidação</h2></div>
    <div class="page-title__right" *appPermission="'CreateReason'">
      <button i18n type="button" class="btn btn-fade-primary mr-2"
        title="Cadastrar Motivo de Invalidação"
        (click)="openCreateOrUpdateReason()">Novo Motivo de Invalidação</button>
      <button i18n type="button" class="btn btn-fade-primary"
        title="Replicar Motivo de Invalidação"
        (click)="openReplicateReason()">Replicar Motivo de Invalidação</button>
    </div>
  </div>

  <!-- Search + Filter -->
  <div class="mb-3">
    <form [formGroup]="searchForm" (submit)="handleSearch()">
      <div class="input-group">
        <input type="text" class="form-control form-search"
          formControlName="search" i18n-placeholder
          placeholder="Buscar por código ou nome"
          (ngModelChange)="searchKey($event)"
          autocomplete="off">
        <div class="input-group-append">
          <button type="button" class="btn btn-outline-secondary"
            (click)="toggleFilter()">
            <i class="material-icons"
              style="vertical-align: middle;">filter_list</i>
            Filtrar
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Filter Panel -->
  <div class="card mb-3" *ngIf="showFilter">
    <div class="card-body">
      <form [formGroup]="filterForm">
        <div class="row">
          <div class="col-md-5">
            <div class="form-group">
              <label i18n>Enquadramento</label>
              <app-input
                type="multiselect"
                formControlName="regulationIds"
                placeholder="Selecione os enquadramentos"
                selectText="shortDescription"
                selectValue="id"
                [list]="regulations"
                selectShowLimit="3">
              </app-input>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label i18n>Tipo de Motivo</label>
              <select class="form-control" formControlName="type">
                <option *ngFor="let opt of typeOptions" [value]="opt.value">{{
                  opt.label }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label i18n>Módulo</label>
              <select class="form-control" formControlName="module">
                <option *ngFor="let opt of moduleOptions" [value]="opt.value">{{
                  opt.label }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <button type="button" class="btn btn-outline-secondary mr-2"
              (click)="resetFilter()" i18n>Redefinir</button>
            <button type="button" class="btn btn-primary"
              (click)="applyFilter()" i18n>Aplicar</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12" *ngIf="!loading">
      <div class="card mb-3" *ngFor="let contractCard of contractCardsPaged">
        <div class="card-body">
          <div
            class="d-flex justify-content-between align-items-center card-header-row"
            (click)="contractCard.isOpen = !contractCard.isOpen"
            style="cursor: pointer;">
            <h5 class="card-title mb-0">
              {{ contractCard.contractCode }} - {{ contractCard.contractName }}
              <span class="badge badge-secondary ml-2">Total: {{
                contractCard.reasons.length }}</span>
            </h5>
            <i class="material-icons">
              {{ contractCard.isOpen ? 'expand_less' : 'expand_more' }}
            </i>
          </div>

          <div *ngIf="contractCard.isOpen" class="mt-3">
            <div class="table-responsive table-hover table-block">
              <table class="table bg-white">
                <thead class="bg-header-table">
                  <tr>
                    <th i18n *appPermission="'UpdateReason'">Habilitado</th>
                    <th i18n class="text-center">
                      <span
                        class="d-flex align-items-center justify-content-center">
                        Código
                        <i class="material-icons btn-sort ml-1"
                          title="Ordenar pelo código"
                          (click)="sortBy('code', contractCard)">{{
                          getSortIcon('code') }}</i>
                      </span>
                    </th>
                    <th i18n class="col-3 text-center">
                      <span
                        class="d-flex align-items-center justify-content-center">
                        Nome
                        <i class="material-icons btn-sort ml-1"
                          title="Ordenar pelo nome"
                          (click)="sortBy('name', contractCard)">{{
                          getSortIcon('name') }}</i>
                      </span>
                    </th>
                    <th i18n class="text-center">Enquadramentos</th>
                    <th i18n class="text-center">Tipo</th>
                    <th i18n class="text-center">Módulos</th>
                    <th i18n class="text-center">Telas</th>
                    <th i18n *appPermission="['UpdateReason','DeleteReason']"
                      class="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let reason of contractCard.reasonsPaged">
                    <td *appPermission="'UpdateReason'">
                      <div class="custom-control custom-switch mt-2">
                        <div class="form-group">
                          <label class="custom-control-label"
                            [ngClass]="{checked: reason.enabled}">
                            <input type="checkbox"
                              class="form-control custom-control-input"
                              *appPermission="'UpdateReason'; contracts reason.contractId"
                              [(ngModel)]="reason.enabled"
                              (change)="updateReasonEdit(reason)">
                          </label>
                        </div>
                      </div>
                    </td>

                    <!-- Código unificado com Código do Cliente -->
                    <td class="text-center" (click)="openReasonView(reason)">
                      <strong>{{ reason.code }}</strong><br>
                      <small class="text-muted">{{ reason.clientCode ? ('Código Cliente: ' + reason.clientCode) : '-' }}</small>
                    </td>

                    <td class="text-center" (click)="openReasonView(reason)">
                      {{ reason.name || '-' }}
                    </td>

                    <!-- Enquadramentos -->
                    <td (click)="openReasonView(reason)">
                      <div
                        *ngFor="let regulationId of reason.regulationIds; let i = index"
                        class="badge badge-secondary mr-1">
                        <div *ngIf="i === 1; else onlyRegulation">
                          <i *ngIf="regulationById[regulationId]"
                            i18n-appTooltip
                            appTooltip="{{ regulationById[regulationId].description || '' }}">
                            {{ regulationById[regulationId]?.code + '...' }}
                          </i>
                        </div>
                        <ng-template #onlyRegulation>
                          <i *ngIf="regulationById[regulationId] && i === 0"
                            i18n-appTooltip
                            appTooltip="{{ regulationById[regulationId].description || '' }}">
                            {{ regulationById[regulationId]?.code }}
                          </i>
                        </ng-template>
                      </div>
                    </td>

                    <!-- Tipo -->
                    <td class="text-center" (click)="openReasonView(reason)">
                      {{ reason.type || '-' }}
                    </td>

                    <!-- Módulos -->
                    <td (click)="openReasonView(reason)">
                      <ng-container
                        *ngIf="reason['applicableModules']?.length > 0; else noModules">
                        <span *ngFor="let mod of reason['applicableModules']"
                          class="badge badge-module mr-1"
                          [ngClass]="mod === 'violation' ? 'badge-infraction' : 'badge-traffic'">
                          {{ getModuleLabel(mod) }}
                        </span>
                      </ng-container>
                      <ng-template #noModules>
                        <span class="text-muted">-</span>
                      </ng-template>
                    </td>

                    <!-- Telas -->
                    <td (click)="openReasonView(reason)">
                      <div *ngIf="reason?.screen?.length > 0; else noItens">
                        <span *ngFor="let screen of reason.screen.slice(0, 2)"
                          class="badge badge-secondary mr-1">
                          {{ stepModesLabel(screen) }}
                        </span>
                        <a *ngIf="reason?.screen?.length > 2"
                          class="badge badge-secondary">+{{ reason.screen.length
                          - 2 }}</a>
                      </div>
                    </td>

                    <td class="text-center"
                      *appPermission="['UpdateReason','DeleteReason']; contracts reason.contractId">
                      <button type="button"
                        class="btn text-secondary btn-icon-block"
                        data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <i class="material-icons">more_horiz</i>
                      </button>
                      <div class="dropdown-menu"
                        aria-labelledby="btnGroupDrop4">
                        <a class="dropdown-item"
                          (click)="openCreateOrUpdateReason(reason)" i18n
                          *appPermission="['UpdateReason']; contracts reason.contractId">
                          Editar Motivo
                        </a>
                        <a class="dropdown-item"
                          (click)="openDeleteModal(reason)" i18n
                          *appPermission="['DeleteReason']; contracts reason.contractId">
                          Remover Motivo
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <app-pagination-simple
              (items)="contractCard.reasonsPaged = $event"
              [data]="contractCard.reasons">
            </app-pagination-simple>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 d-flex justify-content-center">
      <ng-container *ngIf="loading">
        <app-loading [load]="loading"></app-loading>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noItens>
  <span class="text-muted">-</span>
</ng-template>
